import axios from "axios";
import store from "@store/store";
import router from "@router/index";
import crypto from "crypto";
import dayjs from "dayjs";
import { getBroker } from "@utils/util";

// define root api url
let APIURL;
if (process.env.NODE_ENV === "development") {
    APIURL = "/api/v1/";
} else {
    APIURL =
        document.querySelector("body").getAttribute("apiurl") ||
        process.env.VUE_APP_ENDPOINT;
    APIURL = APIURL + "/api/v1/";
}

// create an axios instance
const service = axios.create({
    baseURL: APIURL,
    timeout: 60000,
    crossDomain: true,
    withCredentials: true,
});

const source = axios.CancelToken.source();

// 获取 cookie 值的辅助函数（获取最后一个匹配的值）
function getCookie(name) {
    const cookies = document.cookie.split(";");
    let result = "";
    for (const cookie of cookies) {
        const [key, val] = cookie.trim().split("=");
        if (key === name) {
            result = val;
        }
    }
    return result;
}

// request interceptor
service.interceptors.request.use(
    (config) => {
        // 对于修改数据的请求，添加 CSRF token（PK 平台使用 pk_{broker}_ 前缀）
        if (["post", "put", "delete", "patch"].includes(config.method)) {
            const broker = getBroker().toLowerCase();
            const csrfToken = getCookie(`pk_${broker}_csrf_access_token`);
            if (csrfToken) {
                config.headers["X-CSRF-TOKEN"] = csrfToken;
            }
        }

        if (config.cancelTokenSource) {
            config.cancelToken = config.cancelTokenSource.token;
        }

        return config;
    },
    (error) => {
        // do sth with request error
        Promise.reject(error);
    }
);

service.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // error catch
        if (error.response) {
            // conditional error handler
            switch (error.response.status) {
                case 400:
                    const params = {
                        color: "red",
                        message: error.response.data.msg,
                        status: true,
                        btnName: "Close",
                        timeout: 2000,
                    };
                    store.commit("UPDATE_SNACKBAR", params);
                    break;
                case 404:
                    store.state.snackcolor = "red";
                    store.state.snackmsg = "Error 404, Page Not Found";
                    store.state.snachbar = true;
                    break;
                case 422:
                    store.state.snackcolor = "red";
                    store.state.snackmsg = error.response.msg;
                    store.state.snachbar = true;
                    break;
                case 401:
                    // authorization expired redirect to login page
                    store.state.snackcolor = "red";
                    store.state.snackbar = true;
                    store.state.snackmsg = error.response.data.msg;

                    const saved = localStorage.getItem("locale") || "en";
                    localStorage.clear();
                    localStorage.setItem("locale", saved);

                    source.cancel("");
                    if (window.location.href.indexOf("signin") == -1) {
                        window.location.href = "/#/signin";
                    }
                    break;
                case 500:
                    store.state.snackcolor = "red";
                    store.state.snackbar = true;
                    store.state.snackmsg = "Error 500, Internal Server Error";
                    break;
                case 429:
                    store.state.snackcolor = "red";
                    store.state.snackbar = true;
                    store.state.snackmsg = "Too many request";
                    break;
                case 403:
                    store.state.snackcolor = "red";
                    store.state.snackbar = true;
                    store.state.snackmsg = "Permission Denied";
                    console.log("Permission Denied!");
                    router.go(-1);
                    break;
                case 600:
                    console.log("Error 600");
                    store.state.snackcolor = "red";
                    store.state.snackbar = true;
                    store.state.snackmsg = error.response.data.message;
                    break;
                case 409:
                    store.state.snackcolor = "red";
                    store.state.snackbar = true;
                    store.state.snackmsg = error.response.data.msg;
                    break;
            }
        }
        return Promise.reject(error);
    }
);
const createCancelToken = () => {
    return axios.CancelToken.source();
};

export default service;
export { createCancelToken };
